import { defineCopy } from "@tami/core/intl";

import { CALENDAR_SCRIPT_COPY_EN_US } from "./en-us/calendar-script.copy";
import { CALENDAR_SCRIPT_COPY_ES_ES } from "./es-es/calendar-script.copy";

export const CALENDAR_SCRIPT_COPY_PT_BR = {
  calIntro: {
    narrative:
      "Planeje o mês inteiro num calendário arrastável — postagens, entregas e compromissos na mesma visão.",
  },
  calGrid: {
    narrative:
      "Organize conteúdos por mês ou semana, com data, horário e formato de cada publicação.",
    callout:
      "Calendário arrastável: publi e orgânico com cores diferentes para não confundir.",
  },
  calEventDetail: {
    narrative:
      "Clicar num compromisso abre o que importa dele: quando, com quem e o que foi combinado.",
    callout:
      "Reunião, gravação, call com a marca — o compromisso vive no mesmo lugar do conteúdo.",
  },
  calPostDetail: {
    narrative:
      "E clicar numa postagem abre o detalhe dela: em que etapa está, quando vai ao ar, quanto vale, roteiro, notas e anexos.",
    callout:
      "Etapa, prazo, valor e roteiro numa tela só — sem abrir outra para descobrir.",
  },
  calCreate: {
    narrative:
      "O botão de adicionar pergunta primeiro o que é: compromisso ou postagem.",
    callout:
      "Duas naturezas diferentes, dois caminhos — a cor do ladrilho já é a cor que o item terá.",
  },
  calEventForm: {
    narrative:
      "No compromisso você marca dia, hora e quem participa — e ele entra no calendário na hora.",
    callout:
      "Horário de início e fim, participantes e onde acontece: o suficiente, sem formulário longo.",
  },
  calPostForm: {
    narrative:
      "E a postagem abre o mesmo planejamento da central de conteúdo, já na data escolhida.",
    callout:
      "O mesmo formulário da central de conteúdo — o calendário não inventa um jeito diferente.",
  },
  calOverview: {
    narrative:
      "Marque conteúdos como postados e acompanhe seu progresso ao longo do mês.",
  },
  calSidebar: {
    narrative:
      "Ideias e pendências sem prazo ficam separadas — para nenhuma tarefa sumir no meio da correria.",
    callout:
      "Lista 'para não esquecer': ideias e pendências que ainda não têm data definida.",
  },
  calOutro: {
    narrative:
      "Escreva roteiros, adicione links e exporte — tudo sem sair do calendário.",
  },
} as const;

export const CALENDAR_SCRIPT_COPY = defineCopy(CALENDAR_SCRIPT_COPY_PT_BR, {
  "en-US": CALENDAR_SCRIPT_COPY_EN_US,
  "es-ES": CALENDAR_SCRIPT_COPY_ES_ES,
});
